import { types } from 'mobx-state-tree';

import { BaseDocument } from '../definitions/Common';
import Journey from './Journey';


const InsLifeDocument = BaseDocument
    .named('InsLifeDocument')
    .props({
        schemaVersion: 1,
        
        journey: types.optional(Journey, {}),
    });

export default InsLifeDocument;
